module.exports = __webpack_public_path__ + "static/media/nav-desktop-arrow-l.83ffce37.svg";